module.exports = __webpack_public_path__ + "static/media/Triclorogranulado.5f50200c.png";